import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';
import { reviews } from '../mock';

const Reviews = () => {
  return (
    <section className="py-32 px-6 bg-background">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-5xl md:text-6xl font-serif font-normal text-primary mb-24 text-center tracking-wide">
          Vendégeink mondták
        </h2>
        <div className="grid md:grid-cols-2 gap-12">
          {reviews.map((review, index) => (
            <div key={index} className="bg-transparent border border-border p-10">
              <div className="flex items-center gap-1 mb-6">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-accent text-accent" />
                ))}
              </div>
              <p className="text-xl text-foreground font-serif italic mb-8 leading-relaxed">"{review.text}"</p>
              <div className="flex justify-between items-center border-t border-border/40 pt-6">
                <p className="font-sans text-xs uppercase tracking-widest font-bold text-foreground">{review.name}</p>
                <p className="text-xs text-muted-foreground font-light">{review.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
